<template>
  <div o-Container o-Container-App>
  </div>
</template>

<script>
  export default {
    name: "app_en_database_item", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
      }
    },
    activated: function () {
      this.octopus.applet.infor.lat = this.octopus.tools.parseQuery('lat');
      this.octopus.applet.infor.lng = this.octopus.tools.parseQuery('lng');
      if(this.octopus.tools.parseQuery('youPinName')){
        this.octopus.applet.infor.youPinName = this.octopus.tools.parseQuery('youPinName');
        this.octopus.applet.infor.youPinPass = this.octopus.tools.parseQuery('youPinPass');
      }
      if (this.octopus.tools.parseQuery('model')) {
        this.octopus.applet.model = this.octopus.tools.parseQuery('model');
      }
      document.documentElement.scrollTop = 0;
      // 如果不是移动端，则跳转到web
      this.octopus.tools.isApplet().then(res => {
        if (res) {
          this.login(JSON.parse(decodeURIComponent(this.octopus.tools.parseQuery('loginData'))));
        } else {
          if (!this.octopus.tools.isMobile()) {
            this.octopus.router.jump("/admin/login");
          } else {
            this.octopus.router.jump("/admin/loginApp");
          }
        }
      }).catch(err => {
        alert(err);
      });
      this.octopus.tips.debug("Login.vue执行了activated事件。");
    },
    methods: {
      toPage() {
        if (this.octopus.tools.parseQuery('userInfo')) {
          window.localStorage.setItem('userInfo',this.octopus.tools.parseQuery('userInfo'));
        }
        if (this.octopus.tools.parseQuery('redirectTo')) {
          let redirectTo = this.octopus.tools.parseQuery('redirectTo').split("?");
          let result = '';
          redirectTo.map((item,index) => {
            if (index == 0) result += item
            else if (index == 1) result += '?'+item
            else result += '&' + item;
          });
          this.$router.replace(decodeURIComponent(result));
        } else {
          this.$router.replace('/Applet/Chargingpile/Main/Page')
        }
      },
      login: function (passport) {
        let o = this;
        this.octopus.request.getAjax("POST", "json", this.octopus.config.url + "/charging_pile/applet/gettoken", true, {
          ...passport,
          password: this.octopus.tools.md5(passport.password + passport.timespan),
        },res => {
          if (res.status.code == 200) {
            o.octopus.passport.id = res.content.tokenData.passport.id;
            o.octopus.passport.realName = res.content.tokenData.passport.realName;
            o.octopus.passport.language = res.content.tokenData.passport.language;
            o.octopus.passport.appKey = res.content.tokenData.passport.appKey;
            o.octopus.passport.mobile = res.content.tokenData.passport.mobile;
            // 模板设置样式
            o.octopus.template.choiceTheme(res.content.tokenData.passport.theme);
            // 设置权限
            o.octopus.passport.authorization = res.content.tokenData.passport.authorization;
            o.octopus.passport.token = res.content.tokenData.passport.token;
            let u = navigator.userAgent;
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            if (isAndroid) {
              this.toPage();
            } else {
              o.octopus.applet.wxConfig(false,['scanQRCode','getLocation','openLocation'],() => {
                this.toPage();
              })
            }
          } else {
            this.$toast(res.status.message);
            setTimeout(() => {
              this.octopus.applet.appletLogout();
            },1000)
          }
        })
      },
    },
    props: ["oData"]
  }
</script>



// WEBPACK FOOTER //
// src/components/Applet/Main/Login/Page.vue